import { ColorOptions } from "@/src/types";
import { MainInner } from "@/styles/global";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

type BackgroundImageProps = {
  $backgroundColor: ColorOptions | undefined;
};

type InnerProps = {
  $alignLeft: boolean;
  $backgroundImage: boolean;
};

type TextContainerProps = {
  $alignLeft: boolean;
  $backgroundImage: boolean;
};

const Section = styled.section<BackgroundImageProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor ?? "transparent"]};
  padding: ${({ $backgroundColor }) => ($backgroundColor ? "0" : "88px 0")};
  min-height: 70vh;
`;

const Inner = styled(MainInner)<InnerProps>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 36px 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: row;
    justify-content: ${({ $alignLeft }) =>
      $alignLeft ? "flex-start" : "center"};
    grid-template-columns: 1fr 1fr;
    gap: 100px;
    align-items: ${({ $backgroundImage }) =>
      $backgroundImage ? "flex-start" : "center"};
    padding: 36px 88px;
  }
`;

const BackgroundImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  object-position: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &::after {
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    background: linear-gradient(
      270.01deg,
      rgba(0, 0, 0, 0) 19.42%,
      rgba(0, 0, 0, 0.5) 99.99%
    );
  }
`;

const TextContainer = styled.div<TextContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 24px;
    max-width: ${({ $backgroundImage }) => ($backgroundImage ? "50%" : "100%")};
    margin-left: ${({ $alignLeft }) => ($alignLeft ? "0" : "auto")};
  }
`;

const S = {
  Section,
  Inner,
  BackgroundImage,
  TextContainer,
};

export default S;
